import React from 'react'

import { Icon } from 'elements/media/Icon'
import { EllipsisMultiLines, TEllipsisMultiLinesProps } from 'elements/text/EllipsisMultiLines'
import { Text } from 'elements/text/Text'

import { ICON } from 'config/icons'

import type { TCommunity } from '../types'

export type TCommunityPrivateBadgeProps = {
  community: TCommunity
} & TEllipsisMultiLinesProps

export const CommunityPrivateBadge: TFCC<TCommunityPrivateBadgeProps> = ({ community, ...otherProps }) =>
  community.isPrivate ? (
    <EllipsisMultiLines lines="1" p="12px" color="purple" {...otherProps}>
      <Icon name={ICON.PRIVATE} size="1em" vAlign="text-bottom" m="0 10px 0 0" />
      <Text inline>trans:community:community.private.private</Text>
    </EllipsisMultiLines>
  ) : null
